import React from 'react';
import './App.css';
import VirtualPiano from './components/Piano/virtual_piano';

function App() {
  return (
    <div className="min-h-screen bg-gray-100">
      <VirtualPiano />
    </div>
  );
}

export default App;